import { ShipmentStatus } from '@/constants/shipment';

type Tone = 'warning' | 'info' | 'success' | 'critical' | 'attention' | undefined;
type Progress = 'incomplete' | 'partiallyComplete' | 'complete';

interface StatusInfo {
  tone: Tone;
  progress: Progress;
}

type MappableShipmentStatus = Exclude<ShipmentStatus, ShipmentStatus.All>;

export const shipmentStatusMap: Record<MappableShipmentStatus, StatusInfo> = {
  [ShipmentStatus.Pending]: { tone: undefined, progress: 'incomplete' },
  [ShipmentStatus.NotFound]: { tone: undefined, progress: 'incomplete' },
  [ShipmentStatus.InformationReceived]: { tone: 'info', progress: 'partiallyComplete' },
  [ShipmentStatus.InTransit]: { tone: 'info', progress: 'partiallyComplete' },
  [ShipmentStatus.AvailableForPickup]: { tone: 'success', progress: 'complete' },
  [ShipmentStatus.OutForDelivery]: { tone: 'info', progress: 'partiallyComplete' },
  [ShipmentStatus.Delivered]: { tone: 'success', progress: 'complete' },
  [ShipmentStatus.FailedAttempt]: { tone: 'attention', progress: 'partiallyComplete' },
  [ShipmentStatus.Exception]: { tone: 'attention', progress: 'partiallyComplete' },
  [ShipmentStatus.Expired]: { tone: 'warning', progress: 'partiallyComplete' },
  [ShipmentStatus.CourierNotSupported]: { tone: 'warning', progress: 'complete' },
  [ShipmentStatus.CourierNotDetected]: { tone: 'warning', progress: 'complete' },
  [ShipmentStatus.OverQuota]: { tone: 'critical', progress: 'complete' },
  [ShipmentStatus.OutOfRange]: { tone: 'warning', progress: 'complete' },
  [ShipmentStatus.CourierNotDetected]: { tone: undefined, progress: 'incomplete' },
};

export function getShipmentStatusInfo(status: ShipmentStatus): StatusInfo | undefined {
  return shipmentStatusMap[status as keyof typeof shipmentStatusMap];
}

export const NOT_DETECTED_TRACKING_COMPANIES = [
  'other',
  'Your',
  '',
  'others',
  'overige',
  '其他',
  'その他',
  'Övrigt',
  'Jiný',
  'Autre',
  'Unknown',
];
